export default "__VITE_ASSET__9BP9q1L$__"